module.exports = __webpack_public_path__ + "static/media/logo-grey.2bed6dad.svg";